export default "__VITE_ASSET__DexFZeu9__"